module.exports = __webpack_public_path__ + "img/ecommerce.category.content_image_2.4b69968f.webp";